import {fetch} from "../../../utils/dataAccess";

export function createNewModel (data) {
    return new Promise((resolve, reject) => {
        fetch("/w_m_s_picking_mission_models/create/", {
            method: "POST",
            headers: new Headers({'Content-Type': 'application/json'}),
            body: JSON.stringify({
                inventory: `/inventories/${data.inventory.id}`,
                name: data.name,
                data: data
            })
        })
            .then((response) => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}